import i18next from 'i18next';
import { ModifiedArray } from 'infrastructure/classes/common/modified-array';
import { HoldingStatus } from 'infrastructure/enums';

export interface IHoldingStatusItem {
  id: HoldingStatus | null;
  name: string;
}

type HoldingStatusesArray = ModifiedArray<IHoldingStatusItem>;

interface IProps {
  withAll?: boolean;
  withEmpty?: boolean;
}

export const holdingStatusesDataSource = (
  props?: IProps,
): HoldingStatusesArray => {
  const { withAll = false, withEmpty = false } = props ?? {};
  const dataSource = new ModifiedArray<IHoldingStatusItem>(
    {
      id: HoldingStatus.Active,
      name: i18next.t('holdingStatuses.active'),
    },
    {
      id: HoldingStatus.Hospital,
      name: i18next.t('holdingStatuses.hospital'),
    },
    {
      id: HoldingStatus.Vacation,
      name: i18next.t('holdingStatuses.vacation'),
    },
  );

  if (withEmpty) {
    dataSource.push({
      id: HoldingStatus.Empty,
      name: i18next.t('labels.empty'),
    });
  }

  if (withAll) {
    dataSource.unshift({
      id: null,
      name: i18next.t('labels.all'),
    });
  }

  return dataSource;
};
